import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';
import type { GetChurchesParams } from '@/types/churches';

export const useChurches = (params: GetChurchesParams = {}, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CHURCHES, params],
    queryFn: () => churchesService.getChurches(params),
    enabled,
  });
};
